import React,{Component} from "react";
import logo from "./images/loading.gif";
import save from "./images/save.png";
import fail from "./images/fail.png";
import Table from 'react-bootstrap/Table'
//import Modal from "react-bootstrap/Modal"
//import modallogo from "./images/loader.gif";
import BusyModal from "./modalwait";
import Cookies from "universal-cookie";
import logonorecord from "./images/recordnotfound.png";

//import AdminNotification from "./AdminNotifications";
const cookies=new Cookies()

const axios = require("axios");
const ref = React.createRef();
class NotificationAdmin2 extends Component{
    constructor(props)
    {
        super(props);
           this.state={input:{},ErrMsg2:"",ref:"",UbuttonED:true,RbuttonED:true,savealert:"",removealert:"",value:0,tab1:"block",tab2:"none",tab3:"none",myitems:[],bdisabled:true,isLoaded:false,inputkey:Date.now() ,errorprofile:"",errors:{},error:"",ErrMsg:<img src={logo} alt=""/>,errorcss:"labelerror",filetoupload:null,filename:null,browsecss:"labelblock",savecss:"labelnone",cancelcss:"labelnone"};
           this.handletable = this.handletable.bind(this);
           this.handleSave = this.handleSave.bind(this);
    }
    handletable=(e)=>{
        let index = e.target.value;
        let input = this.state.input;
        input["rtitle"] = this.state.myitems[index]["title"];
        input["rref"] = this.state.myitems[index]["ref"];
        input["rdesc"] = this.state.myitems[index]["description"];
        input["filepath"] = this.state.myitems[index]["filepath"];
        this.setState({input,RbuttonED:false,ref:this.state.myitems[index]["ref"]});
    }
    handleSave=()=>{
        if(this.validate())
        {
            document.body.style.cursor="wait";
            this.setState({ErrMsg2:<BusyModal/>});
        
            axios({
                method:"post",
                url:cookies.get("phpclass")+'/index.php/user/SaveupdateNotifications/',
                data: this.state.input,
                headers: {'Content-Type': 'multipart/form-data'}            
                })
                .then((res) => {
                if(res.data === 0)
                {
                    this.setState({ErrMsg2:"",savealert:<span><img src={save} style={{width:'40px', height:'35px',paddingBottom:'5px'}}/>Successfully updated.</span>,errorcss:"labelsave"});
                    document.body.style.cursor ="default";
                }
                else
                {
                    this.setState({ErrMsg2:"",savealert:<span><img src={fail} style={{width:'40px', height:'35px',paddingBottom:'5px'}}/>Failed to update.</span>,errorcss:"labelerror"});
                    document.body.style.cursor ="default";
                }
            })
        }
    }
    handleRemove=()=>{
        document.body.style.cursor="wait";
        this.setState({ErrMsg2:<BusyModal/>});
        axios({
            method:"post",
            url:cookies.get("phpclass")+'/index.php/user/removeNotification/'+this.state.ref,
            headers: {'Content-Type': 'multipart/form-data'}
        })
        .then((res)=>{
            document.body.style.cursor="default";
            if(res.data === 1)
                this.setState({ErrMsg2:"",savealert:<span><img src={save} style={{width:'40px', height:'35px',paddingBottom:'5px'}}/>Notification has been removed.</span>,RbuttonED:true,UbuttonED:true});
            else
                this.setState({ErrMsg2:"",savealert:<span><img src={fail} style={{width:'40px', height:'35px',paddingBottom:'5px'}}/>Failed to remove Notification.</span>});
            })
        .catch(()=>{
            document.body.style.cursor="default";
            this.setState({ErrMsg2:"",savealert:"It might be connection error."});
        })
    }
    handleFileUploadR=()=> 
    {
        if(this.state.filetoupload !== null)
        {
            this.setState({ErrMsg2:<BusyModal/>});
            document.body.style.cursor ="wait";
            const formdata = new FormData() 
            formdata.append("myfile[]", this.state.filetoupload,this.state.filename);
            formdata.append("ref", this.state.input["rref"]);
            formdata.append("oldfile", this.state.input["filepath"]);

            axios.post(cookies.get("phpclass")+'/index.php/user/uploadFileR/',formdata, {
                }).then((res) => {
                if(res.data === 0)
                {
                    this.setState({ErrMsg2:"",uploadalert:<span><img src={save} style={{width:'40px', height:'35px',paddingBottom:'5px'}}/>Uploaded</span>,errorcss:"labelsave"});
                    this.setState({inputkey:Date.now(),filetoupload: "",filename: "",browsecss:"labelblock",savecss:"labelnone",cancelcss:"labelnone"});    
                    document.body.style.cursor ="default";
                }
                else
                {
                    this.setState({ErrMsg2:"",uploadalert:<span><img src={save} style={{width:'40px', height:'35px',paddingBottom:'5px'}}/>Uploaded failed</span>,errorcss:"labelerror"});
                    document.body.style.cursor ="default";
                }
           })
        }
        else
        {
            this.setState({ErrMsg2:"",error:"Must select a file to upload",errorcss:"labelerror"});
            document.body.style.cursor ="default";
        }
    }

    Imagechange=(event)=>
    {
        this.setState({error:"",UbuttonED:false,filetoupload: event.target.files[0],filename: event.target.files[0].name,imagefile:URL.createObjectURL(event.target.files[0]),browsecss:"labeblock",savecss:"labelblock",cancelcss:"labelblock"});
    }
    Imagecancel=(event)=>
    {       
        this.setState({inputkey:Date.now(),error:"",filetoupload: "",filename: "",imagefile:this.state.defaultimage,browsecss:"labelblock",savecss:"labelnone",cancelcss:"labelnone"});
    }

    componentDidMount()
    {
        document.body.style.cursor="wait";
        axios({
            method: 'post',
            url: cookies.get("phpclass")+'/index.php/user/GetDocuments/',
            headers: {'Content-Type': 'multipart/form-data'}
            })

            .then((response)=> {
                document.body.style.cursor="default";

                if(response.data === 0)
                    this.setState({isLoaded:false,ErrMsg:<img src={logonorecord} alt=""/> });
                else
                    this.setState({myitems:response.data,ErrMsg:""});
            })
            .catch((response)=> {
                 document.body.style.cursor="default";
                /*this.setState({errorprofile:response.error,errorcss:"labelerror",bdisabled:false});*/
            }); 
    }

    //Change of input fields
    handleFiledsChangeR=(event)=>
    {
        let input = this.state.input;
        input[event.target.name]=event.target.value;
        this.setState({input});      
    }

    //Change of input fields
    handleFiledsChange=(event)=>
    {
        let input = this.state.input;
        input[event.target.name]=event.target.value;
        this.setState({input});      
    }

  
    validate(){
        let input = this.state.input;
        let errors = {};
        let isValid = true;
        //For email
        if (input["rtitle"].length == 0 ) {      
            isValid = false;
            errors["rptitle"] = "Please enter title.";          
        }                
        if (input["rdesc"].length == 0) {      
            isValid = false;
            errors["rpdesc"] = "Please enter description.";
        }                
      this.setState({errors: errors});
        return isValid;
    }        
    render(){
        let items = this.state.myitems;
        let isLoaded = this.state.isLoaded;   
        if(!isLoaded) 
        {
            return (
                <div className="container1">            
                    <div className="center">
                          {this.state.ErrMsg}
                    </div>
                </div>
            )
        } 
        else 
        {
        return(
/*            <div width="100%" align="center" height="100%" scroll="hidden" >*/
            <div className="inner-profile" >
                <h5 style={{textAlign:"center"}}>Policies and documents</h5>
                <div className="inner-profile2" >
                    <div className="form-group row">
                        <br></br>
                        <div style={{width:"100%",maxHeight:"400px" }}>
                            <Table striped bordered hover variant="dark">
                                <thead>
                                    <tr>
                                        <th style={{width:"5%",padding:"5px 2px 5px 5px"}} >#</th>
                                        <th style={{width:"25%",padding:"5px 2px 5px 5px"}}>Reference#</th>
                                        <th style={{width:"20%",padding:"5px 2px 5px 5px"}}>Date</th>
                                        <th style={{width:"40%",padding:"5px 2px 5px 5px"}}>Title</th>
                                        <th style={{width:"10%",padding:"5px 2px 5px 5px"}}>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {items.map((result, i)=>{
                                        return(
                                            <tr key={i} >
                                                <td style={{height:"10px",padding:"2px 2px 2px 5px"}}>{i+1}</td>
                                                <td style={{height:"10px",padding:"2px 2px 2px 5px"}}>{result.ref}</td>
                                                <td style={{height:"10px",padding:"2px 2px 2px 5px"}}>{result.pdate}</td>
                                                <td style={{height:"10px",padding:"2px 2px 2px 5px"}}>{result.title}</td>
                                                <td style={{height:"10px",padding:"2px 2px 2px 5px"}}><button onClick={this.handletable} value={i}>Edit</button></td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                    <div className="form-group row">
                        <br></br>
                        <label>Reference#:</label>
                        <input type="text" name="rref" disabled={true} value={this.state.input["rref"]} className="form-control" />
                        <label>Title:</label>
                        <input type="text" name="rtitle" value={this.state.input["rtitle"]} className="form-control" onChange={this.handleFiledsChangeR}/>
                        <small id="rptitle" className="text-danger">{this.state.errors.rptitle}</small>
                    </div>
                    <div className="form-group row">
                        <label>Detail or description:</label>
                        <textarea rows={10} name="rdesc" value={this.state.input["rdesc"]} cols={100} className="form-control" onChange={this.handleFiledsChangeR}/>
                        <small id="rptitle" className="text-danger">{this.state.errors.rpdesc}</small>
                        <div style={{width:"40%",float:"left",height:"50px",textAlign:"left"}}>
                            <label className={this.state.errorcss}>{this.state.savealert}</label>
                        </div>
                        <div style={{width:"60%",float:"left",height:"50px",textAlign:"right"}}>
                            <span style={{width:"100%",textAlign:"right",marginTop:"10px"}}>
                            <button
                                className=".btn btn-secondary btn-sm"
                                onClick={this.handleRemove}
                                disabled={this.state.RbuttonED}
                                style={{alignSelf:"right",width:"75px",margin:"5px"}}
                                >
                                Remove
                            </button>
                            <button
                                className=".btn btn-secondary btn-sm"
                                onClick={this.handleSave}
                                disabled={this.state.RbuttonED}
                                style={{alignSelf:"right",width:"75px"}}
                                >
                                Save
                            </button>
                            </span>
                        </div>
                    </div>
                </div>
                <div style={{width:"55%",float:"left",marginLeft:"0px",textAlign:"left",border:"1px"}} >
                    <input
                        type="text"
                        className="form-control"
                        name="rrmyfile"
                        disabled
                        value={this.state.input["filepath"]}
                        />
                        <label className="labelerror" >
                            <span className={this.state.errorcss}>{this.state.error}</span>
                        </label>
                        </div>
                        <div style={{width:"15%",float:"left",paddingTop:"3px"}}>
                            Existing file
                        </div>
                        <div style={{width:"20%",float:"left"}}>
                            <span className={this.state.errorcss}>{this.state.removealert}</span>
                        </div>
                        <div style={{width:"55%",float:"left",marginLeft:"0px",textAlign:"left",border:"1px"}} >
                            <input
                                type="file"
                                className="form-control"
                                name="myfile"    
                                onChange={this.Imagechange}
                                />
                        </div>
                        <div style={{width:"10%",float:"left",paddingTop:"5px"}}>
                            <button
                                className=".btn btn-secondary"
                                onClick={this.handleFileUploadR}
                                disabled={this.state.UbuttonED}
                                style={{height:"30px",width:"60px"}} 
                                >
                                Upload
                            </button>
                        </div>
                        <div style={{width:"20%",float:"left",paddingTop:"0px"}}>
                            <span className={this.state.errorcss}>{this.state.uploadalert}</span>
                        </div>
                        {this.state.ErrMsg2}
                    </div>
                        
    )}
}}
export default NotificationAdmin2;